import { render, staticRenderFns } from "./LeadUpcomingAppointment.vue?vue&type=template&id=2b30684e&"
import script from "./LeadUpcomingAppointment.vue?vue&type=script&lang=js&"
export * from "./LeadUpcomingAppointment.vue?vue&type=script&lang=js&"
import style0 from "./LeadUpcomingAppointment.vue?vue&type=style&index=0&id=2b30684e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports